import React, { Component } from 'react';
import { connect } from 'react-redux';
import Calculator from './Calculator.jsx';
import Calendar from './Calendar.jsx';
import Clock from './Clock.jsx';
import Email from './Email.jsx';
import Signin from './Signin.jsx';
import Map from './Map.jsx';
import './Elements.css';

const mapStateToProps = (state) => {
  return {
    fonts: state.fonts,
  }
}

class Elements extends Component {
  render() {

    return (
      <div className="elements-wrapper">
        <Calculator />
        <Calendar />
        <Clock />
        <Email />
        <Signin />
        <Map />
      </div>
    )
  }
}

export default Elements = connect(mapStateToProps, undefined)(Elements);



// WEBPACK FOOTER //
// ./src/components/generator/elements/Elements.jsx